// Nevilife shared interactions

(function () {
  // Header scroll: announcement bar collapses + nav shrinks
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 30) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Dynamically set main padding-top to match header height (logo, announcement bar etc. change height)
    const setMainPadding = () => {
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    };
    setMainPadding();
    window.addEventListener('resize', setMainPadding, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(setMainPadding).observe(header);
    }
  }

  // Active nav link: page-path match + scroll IntersectionObserver
  const allNavLinks = document.querySelectorAll('.nav-link, .mobile-link');
  const currentPath = window.location.pathname;
  const currentHash = window.location.hash;

  // Page-based active: highlight menu items whose URL matches current path
  allNavLinks.forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    try {
      const url = new URL(href, window.location.origin);
      if (url.pathname === currentPath && url.pathname !== '/') {
        link.classList.add('is-active');
      } else if (url.pathname === '/' && currentPath === '/') {
        link.classList.add('is-active');
      }
    } catch (e) {}
  });

  // Scroll-based active for anchor links (e.g. #products, #faq)
  const sections = document.querySelectorAll('section[id]');
  const anchorLinks = document.querySelectorAll('.nav-link[href^="#"], .mobile-link[href^="#"]');
  if (sections.length && anchorLinks.length) {
    const setAnchorActive = (id) => {
      anchorLinks.forEach((l) => {
        l.classList.toggle('is-active', l.getAttribute('href') === '#' + id);
      });
    };
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setAnchorActive(e.target.id);
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    sections.forEach((s) => io.observe(s));
  }

  // Mobile drawer
  const drawer = document.getElementById('mobile-drawer');
  const overlay = document.getElementById('mobile-overlay');
  const openDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.add('open');
    overlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove('open');
    overlay.classList.add('hidden');
    document.body.style.overflow = '';
  };
  document.getElementById('mobile-toggle')?.addEventListener('click', openDrawer);
  document.getElementById('mobile-close')?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.querySelectorAll('.mobile-link').forEach((l) => l.addEventListener('click', closeDrawer));

  // Reveal on scroll
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const revealIO = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            revealIO.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach((el) => revealIO.observe(el));
  }

  // Sticky mobile CTA: show after hero scrolled past
  const mobileCta = document.getElementById('mobile-cta');
  if (mobileCta) {
    const updateMobileCta = () => {
      const hero = document.querySelector('[data-hero]');
      const heroEnd = hero ? hero.offsetHeight : 600;
      const past = window.scrollY > heroEnd;
      const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 200;
      mobileCta.classList.toggle('show', past && !nearBottom);
    };
    window.addEventListener('scroll', updateMobileCta, { passive: true });
    updateMobileCta();
  }
})();
